module.exports = __webpack_public_path__ + "img/logo.9cbb6660.png";